import { Filter, Text } from '@/components/DesignSystem';
import { Stack } from '@mui/material';
import { useState } from 'react';

type FilterQuery = Record<string, string | string[] | undefined>;

const statusOptions = ['Accepted', 'Closed', 'Open', 'Draft'];

export const FilterDemo = () => {
  const [selectedFilters, setSelectedFilters] = (
    useState<FilterQuery>({})
  );
  return (
    <Stack spacing={2}>
      <Text>
        Selected filters: {JSON.stringify(selectedFilters)}
      </Text>
      <Filter<FilterQuery>
        filters={[{
          id: 'offerStatus',
          label: 'Status',
          options: statusOptions.map(
            (value) => ({ id: value, label: value }),
          ),
        }]}
        onChange={(filters) => setSelectedFilters(filters)}
        recordName={{
          plural: "Product requests",
          singular: "Product request",
        }}
        testID="filter-demo"
        totalResults={10}
      />
    </Stack>
  );
};
